import { createMigration } from './utils';

const NEW_Y_POSITIONS_BY_ASPECT_RATIO: Record<string, number> = {
    landscape: 970,
    vertical: 1340,
    square: 950,
    fourfive: 1220,
};

function updateTransformation(
    map: any,
    path: (string | number)[],
    newYAnchor: number,
    newYPosition?: number,
) {
    map.setIn([...path, 'transformation', 'anchor', 'y'], newYAnchor);
    if (newYPosition !== undefined) {
        map.setIn([...path, 'transformation', 'position', 'y'], newYPosition);
    }
}

export const migrationTo9_225 = createMigration({
    migrateVideo(video) {
        return video.withMutations((map) => {
            map.get('slides').forEach((scene, i: number) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        const sceneDesignId = scene.get('sceneDesign');
        const sceneCategory = scene.get('sceneCategory');

        if (
            !sceneDesignId ||
            !sceneCategory ||
            !sceneDesignId.includes('caption_') ||
            sceneCategory !== 'caption'
        ) {
            return scene;
        }

        const aspectRatio = scene.get('aspectRatio');
        const newYPosition = NEW_Y_POSITIONS_BY_ASPECT_RATIO[aspectRatio];
        const newYAnchor = 0.5;

        return scene.withMutations((map) => {
            map.get('children', []).forEach((_child, cIndex: number) => {
                const path = ['children', cIndex];
                const asset = map.getIn(path) as any;
                if (!asset) {
                    return;
                }
                const childClassType = asset.get('classType');
                if (childClassType !== 'CanvasTextAsset') {
                    return;
                }
                // we don't need to migrate this scene if the y anchor is already 0.5
                const currentYAnchor = asset.getIn(['transformation', 'anchor', 'y']);
                if (currentYAnchor === newYAnchor) {
                    return;
                }
                updateTransformation(map, path, newYAnchor, newYPosition);
            });

            const textPositionPresets = map.get('textPositionPresets');
            if (textPositionPresets && textPositionPresets.size > 0) {
                const firstPresetKey = textPositionPresets.keySeq().first();
                const presetAssets = textPositionPresets.get(firstPresetKey);
                presetAssets.forEach((asset, pIndex: number) => {
                    if (
                        asset.get('classType') !== 'CanvasTextAsset' &&
                        asset.get('classType') !== 'CanvasFancyCaptionAsset'
                    ) {
                        return;
                    }
                    const currentYAnchor = asset.getIn(['transformation', 'anchor', 'y']);
                    if (currentYAnchor === newYAnchor) {
                        return;
                    }
                    const path = ['textPositionPresets', firstPresetKey, pIndex];
                    updateTransformation(map, path, newYAnchor, newYPosition);
                });
            }
        });
    },
});
